import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { l as lodash_debounce } from './index3.js';

const Portal = /*@__PURE__*/ proxyCustomElement(class Portal extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.observer = new MutationObserver(lodash_debounce(this.setPosition.bind(this), 200));
    this.offsetX = 0;
    this.offsetY = 0;
    this.name = `portal-${String(Math.ceil(Date.now() * Math.random()))}`;
    this.reference = undefined;
  }
  handlePosition() {
    this.setPosition();
  }
  componentWillLoad() {
    const oldPortal = document.body.querySelector(`#${this.name}`);
    if (oldPortal) {
      oldPortal.remove();
    }
    this.createPortal();
  }
  componentDidLoad() {
    this.moveElementToPortal();
    this.setPosition();
    this.observer.observe(document.body, { childList: true, subtree: true });
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  handleResize() {
    this.setPosition();
  }
  handleScroll() {
    this.setPosition();
  }
  createPortal() {
    this.portal = document.createElement('div');
    this.portal.setAttribute('id', this.name);
    this.portal.style.zIndex = '10000';
    this.portal.style.position = 'absolute';
    document.body.append(this.portal);
  }
  moveElementToPortal() {
    this.portal.appendChild(this.element);
  }
  setPosition() {
    if (this.reference) {
      const { top, left, width } = this.reference.getBoundingClientRect();
      this.portal.style.top = `${window.scrollY + top + this.offsetY}px`;
      this.portal.style.left = `${window.scrollX + left + this.offsetX}px`;
      this.portal.style.width = `${width}px`;
    }
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
  get element() { return this; }
  static get watchers() { return {
    "reference": ["handlePosition"]
  }; }
}, [4, "skp-portal", {
    "offsetX": [2, "offset-x"],
    "offsetY": [2, "offset-y"],
    "name": [1],
    "reference": [16]
  }, [[9, "resize", "handleResize"], [11, "scroll", "handleScroll"]], {
    "reference": ["handlePosition"]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["skp-portal"];
  components.forEach(tagName => { switch (tagName) {
    case "skp-portal":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Portal);
      }
      break;
  } });
}

export { Portal as P, defineCustomElement as d };
